import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import App from './App'
import '@itsrever/design-system/index.css'
import './index.css'
import './i18n'
import { ThemeProvider, Toaster } from '@itsrever/design-system'
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js'
import { BrowserRouter } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { initializeSentry } from '@/infrastructure/sentry'
import { initializePosthog } from '@/infrastructure/posthog'
import { getQueryClient } from '@/infrastructure/react-query'
import { Auth0ProviderWithNavigate } from './utils/auth0-provider-with-navigate'

const development = import.meta.env.VITE_DEVELOPMENT
const sentryDSN = import.meta.env.VITE_SENTRY_DSN
const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY

if (!development) {
  initializeSentry(sentryDSN)
  initializePosthog(posthogApiKey)
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <QueryClientProvider client={getQueryClient()}>
            <ThemeProvider>
              <App />
              <Toaster />
            </ThemeProvider>
          </QueryClientProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </PostHogProvider>
  </Provider>
)
